import { useLocation, matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function useActiveLink(path, deep = true, hasChild) {
  const { pathname } = useLocation();
  const normalActive = path ? !!matchPath({ path, end: true }, pathname) : false;
  const deepActive = path ? !!matchPath({ path: path.endsWith("/*") ? path : `${path}/*`, end: deep }, pathname) : false;
  return {
    active: deep ? deepActive : normalActive,
    // isExternalLink: path.includes('http'),
    isExternalLink: hasChild > 0,
  };
}
